import React from "react";
import { render } from "react-dom";
import page from "page";
import urljoin from "url-join";

import Search from "../components/search.jsx";
import Favoritos from "../components/favoritos.jsx";
import PlayedGames from "../components/playedgames.jsx";
import SelectLanguage from "../components/selectLanguage.jsx";
import LinkObfuscate from "../helpers/LinkObfuscate";
import gamesPlayed from "../helpers/games_played";
import adblockDetect from "../helpers/adblockDetect";
import gaTrack from "../helpers/gaTrack";
import dfpReload from "../helpers/dfpReload";
import urlPrefetch from "../helpers/urlPrefetch";
import favorites from "../helpers/favorites";
import log from "../helpers/log";
import sessionkey from "../helpers/sessionkey";
import geoCookies from "../helpers/geoCookies";
import userTrack from "../helpers/userTrack";
import { Newsletter } from "../components/Newsletter.jsx";

function testWebP() {
	return new Promise(res => {
		const webP = new Image();
		webP.src =
			"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
		webP.onload = webP.onerror = function() {
			res(webP.height === 2);
		};
	});
}
function isRetinaDisplay() {
	if (window.matchMedia) {
		const mq = window.matchMedia(
			"only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 4/2), only screen and (-webkit-min-device-pixel-ratio: 2), only screen  and (min-device-pixel-ratio: 2), only screen and (min-resolution: 2dppx)"
		);
		return (mq && mq.matches) || window.devicePixelRatio > 1;
	}
}

export default () => {
	window.mobile = false;
	window.hasWebP = false;
	testWebP().then(hasWebP => {
		window.hasWebP = hasWebP;
		if (!hasWebP) {
			document.getElementsByTagName("body")[0].classList.add("nowebp");
		}
	});
	window.isRetinadisplay = isRetinaDisplay();
	try {
		if (typeof localStorage === "object") {
			try {
				localStorage.setItem("localStorage", 1);
				localStorage.removeItem("localStorage");
			} catch (e) {
				Storage.prototype._setItem = Storage.prototype.setItem;
				Storage.prototype.setItem = function() {};
				alert(translate.LOCALSTORAGE_ERROR);
			}
		} else {
			alert(translate.LOCALSTORAGE_ERROR);
		}
	} catch (e) {
		alert(translate.LOCALSTORAGE_ERROR);
	}

	BrowserDetect.init();

	// Browser and Version
	$("html").addClass(BrowserDetect.browser.toLowerCase());
	$("html").addClass(
		`${BrowserDetect.browser.toLowerCase()}-${BrowserDetect.version}`
	);

	// IE Hack
	if ($("html").hasClass("explorer-10")) {
		$(".Main-search-result").append(
			'<iframe id="fake"  frameBorder="0" width="1" height="1" src="about:blank"></iframe>'
		);
		$(".Main-languages").hover(
			() => {
				$(".Category-secondaryNav").css(
					"margin-right",
					$(".Category-secondaryNav li:nth-of-type(3)").outerWidth()
				);
				$(".Category-secondaryNav li:nth-of-type(3)").hide();
			},
			() => {
				$(".Category-secondaryNav li:nth-of-type(3)").show();
				$(".Category-secondaryNav").css("margin-right", "0");
			}
		);
	}

	render(<Search />, document.getElementById("Main-search"));
	window.cdns = ["//cdn.pomu.es/"];
	if (window.location.href.toString().indexOf("dev.") !== -1) {
		window.cdns = ["//cdn.dev.juegosjuegos.com/"];
	}

	// User Info
	sessionkey();

	// Favorite Games

	favorites.migrate();

	favorites.load();

	window.showFavoritosListTitle = true;

	// Played Games
	const gp = new gamesPlayed();
	gp.migrate();
	gp.load();

	render(
		<Newsletter
			translate={translate}
			isChrome={window.chrome}
			host={window.location.host}
		/>,
		document.getElementById("newsletter")
	);

	if (
		window.section != "error404" &&
		document.getElementById("selectLanguageContainer") !== null
	) {
		document.getElementById("selectLanguageContainer").innerHTML = "";
		render(
			<SelectLanguage
				showSecondary={window.location.search.includes("?language")}
			/>,
			document.getElementById("selectLanguageContainer")
		);
	} else if (window.section == "error404") {
		$(".Main-languages").remove();
	}
	// Geo Cookies

	geoCookies();

	if (GOOGLE_TAG_MANAGER_ENABLED) {
		userTrack();
	}

	LinkObfuscate();

	// Detect Adblock
	const adblockDetectVar = new adblockDetect();

	// Analytics Events
	const gaTrackVar = new gaTrack();

	// DFP Reload
	const dfpReloadVar = new dfpReload();

	// Prefetch url on hover
	const urlPrefetchVar = new urlPrefetch();
	urlPrefetchVar.detectar();

	window.rendered = new Date();

	if (window.location.hash !== "") {
		page();
	}
};
